import { render, staticRenderFns } from "./AppointmentsCalendar.vue?vue&type=template&id=64942b97&lang=pug"
import script from "./AppointmentsCalendar.vue?vue&type=script&lang=ts"
export * from "./AppointmentsCalendar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports